import React, { useEffect, useState } from "react";
import ImageCard from "../../../components/card/ImageCard";
import PageBanner from "../../../components/PageBanner";
import Pagination from "../../../components/Pagination";
import VideoService from "../../../services/video";
import BannerService from "../../../services/banner";
import { useParams } from "react-router-dom";
import { videoSize } from "../../../configs/pageSize";

export default function Video() {
  let [videoData, setVideoData] = useState(null);
  let [meta, setMeta] = useState({});
  const [page, setPage] = useState(1);
  // eslint-disable-next-line
  const [pageSize, setPageSize] = useState(videoSize);
  let [videoBanner, setVideoBanner] = useState([]);
  let { lang } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
    getVideoBanner();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getVideoData();

    // eslint-disable-next-line
  }, [page, pageSize]);

  //return lang function
  useEffect(() => {
    if (lang !== "th" && lang !== "en") {
      window.open(`/th`, "_self");
    }
  });

  const getVideoData = async () => {
    try {
      let [res, meta] = await VideoService.getVideo({
        page: page,
        pageSize: pageSize,
      });
      setVideoData(res);
      setMeta(meta);
    } catch {
      console.error();
    }
  };

  const getVideoBanner = async () => {
    try {
      let res = await BannerService.getBanner(6);
      setVideoBanner(res);
    } catch {
      console.error();
    }
  };

  const bannerText = [{ name: "Video collection", href: "/video" }];

  return (
    <div id="video" className="pt-[135px] lg:pt-[0px]">
      <PageBanner
        text_th={"รวบรวมวิดีโอความรู้"}
        text_en={"Video collection"}
        banner={videoBanner?.banner}
        bannerText={bannerText}
        lang={lang}
      />

      <div className="section">
        <div className="page-container">
          {/* นัดหมาย */}
          <div className="mt-[92px] mb-[300px]">
            <h1 className="text-heading font-bold text-slateGray text-left">
              {lang === "th" ? "รวมวิดีโอ" : "Videos"}
            </h1>

            <div
              id="image-activity"
              className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 lg:flex-row gap-[50px] mt-[68px]"
            >
              {videoData &&
                videoData.map((item, i) => (
                  <ImageCard data={item} isVideo={true} key={i} lang={lang} />
                ))}
            </div>

            {videoData && (
              <Pagination
                length={meta?.pagination?.pageCount ?? ""}
                selected={page}
                function={(i) => {
                  setPage(i);
                }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
